import { render, staticRenderFns } from "./bounce-capsule.vue?vue&type=template&id=6188e242&"
import script from "./bounce-capsule.vue?vue&type=script&lang=ts&"
export * from "./bounce-capsule.vue?vue&type=script&lang=ts&"
import style0 from "./bounce-capsule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports